module.exports = __webpack_public_path__ + "static/assets/43194fd6b93d98e7ed7cdda4d1bd7997.svg";